import { useMemo } from "react";

import { useSelector } from "react-redux";

import { getBusinesses } from "selectors";

// Extends Record to satisfy AgGridTable's context prop, which loses excess
// property checking.
export interface SideLoadedBusinessGridContext extends Record<string, unknown> {
  businessesById: StateModelById<Business>;
  handleSelectAndCompare: (recordId: string) => void;
}

export const getSideLoadedBusinessRowId = (params: {
  data: SideLoadedBusiness;
}): string => params.data.id;

export function useSideLoadedBusinessGridContext(
  handleSelectAndCompare: (recordId: string) => void,
): SideLoadedBusinessGridContext {
  const businessesById: StateModelById<Business> = useSelector(getBusinesses);

  return useMemo(
    () => ({ businessesById, handleSelectAndCompare }),
    [businessesById, handleSelectAndCompare],
  );
}
